import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AadRoleService } from '../services/aad-role.service';

/**
 * Blocks navigation to admin routes unless the signed-in user
 * has the AAD "ADMIN" app role.
 *
 * If the user is not an AAD admin they are redirected to /dashboard.
 */
@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(
    private readonly aadRoles: AadRoleService,
    private readonly router: Router,
  ) {}

  canActivate(): boolean {
    if (this.aadRoles.isAdmin) {
      return true;
    }

    console.warn('[AdminGuard] Access denied — user does not have AAD ADMIN role');
    this.router.navigate(['/dashboard']);
    return false;
  }
}
